export const DeleteMultiSelectValues = (setUiValue) => {
  const handleDelete = (index) => {
    setUiValue((prevValues) => prevValues.filter((_, i) => i !== index));
  };
  return handleDelete;
};
